import React from "react";
import { Navigate } from "react-router-dom";
import routePaths from "./route-paths";
import Login from "../modules/Login";
import Dashboard from "../modules/Dashboard";
import ForgotPassword from "../modules/ForgotPassword";
import ManageUsers from "../modules/ManageUsers";
import ViewUser from "../modules/ManageUsers/ViewUser";
import UserModification from "../modules/UserModification";
import ManageCategories from "../modules/ManagedCategories";
import ChangePassword from "../modules/ChangePassword";
import Settings from "../modules/SettingModule";
import ManageFaqs from "../modules/ManageFaqs";
import ManageTicket from "../modules/ManageTicket";
import PostDetail from "../modules/ManageTicket/PostDetail";
import CommentDetail from "../modules/ManageTicket/CommentDetail";
import UserReportDetail from "../modules/ManageTicket/UserDetail";
import ManageChallenge from "../modules/ManageChallenge";
import ManageTheme from "../modules/ManageTheme";
import ManagePolls from "../modules/ManagePolls";
import ManageBadge from "../modules/ManageBadge";
import ManageAudio from "../modules/ManageAudio";
import ManageKaraoke from "../modules/ManageKaraoke";
import UploadKaraokeFile from "../modules/ManageKaraoke/UploadKaraokeFile";
import ManageDance from "../modules/ManageDance";
import UploadDanceFile from "../modules/ManageDance/UploadDanceFile";
import ManageWrap from "../modules/ManageWrap";
import ManageContests from "../modules/ManageContests";
import ManageFeedback from "../modules/ManageFeedback";
import AdminSettings from "../modules/ManageAdminSettings";
import ManageAdminAccounts from "../modules/ManageAdminAccounts";
import GameplaySettings from "../modules/ManageGameplaySettings";
import ManageFaceVerification from "../modules/ManageFaceVerification";
import ManageSeason from "../modules/ManageSeason";
import ManageAppeals from "../modules/ManageAppeals";
import AntiCheat from "../modules/AntiCheat";
import ManageNotifications from "../modules/ManageNotifications";
import ManageMessages from "../modules/ManageMessages";
import ManagePatchUpdates from "../modules/ManagePatchUpdates";
import ManagePagentPosts from "../modules/ManagePagentPosts";
import Calendar from "../modules/Calendar";
import CalendarPrint from "../modules/Calendar/CalendarPrint";
import CuratedMatches from "../modules/CuratedMatches";
import FilmFeed from "../modules/FilmFeed";
import Conversion from "../modules/Conversion";
import Sales from "../modules/Sales";
import MobilePage from "../modules/Mobile";
import ProtectedRoute from "../components/ProtectedRoute";

const routes = [
  {
    path: routePaths.HOME,
    element: (props = {}) => <Login {...props} />,
  },
  {
    path: routePaths.RESETPASSWORD,
    element: (props = {}) => <ForgotPassword {...props} />,
  },
  {
    path: routePaths.NOT_FOUND,
    element: (props = {}) => <Login {...props} replace />,
  },
];

const loginRoutes = [
  {
    path: routePaths.HOME,
    element: () => <Navigate to={routePaths.DASHBOARD} replace />,
  },
  {
    path: routePaths.DASHBOARD,
    element: (props = {}) => (
      <ProtectedRoute>
        <Dashboard {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_USERS,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageUsers {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.REPORTS,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <Conversion {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.SALES,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <Sales {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // Old bookmark: Conversion became Reports
    path: routePaths.CONVERSION,
    element: () => <Navigate to={routePaths.REPORTS} replace />,
  },
  {
    path: routePaths.MOBILE,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <MobilePage {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.VIEW_USER,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ViewUser {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.BAN_USER,
    element: () => <Navigate to={routePaths.USER_MODIFICATION} replace />,
  },
  {
    path: routePaths.USER_MODIFICATION,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <UserModification {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_CATEGORY,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageCategories {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_CHALLENGE,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageChallenge {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_THEME,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageTheme {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_POLLS,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManagePolls {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_CONTESTS,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageContests {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.CALENDAR,
    element: (props = {}) => (
      <ProtectedRoute>
        <Calendar {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.CALENDAR_PRINT,
    element: (props = {}) => (
      <ProtectedRoute>
        <CalendarPrint {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.CHANGE_PASSWORD,
    element: (props = {}) => (
      <ProtectedRoute>
        <ChangePassword {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_BADGE,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageBadge {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_AUDIO,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageAudio {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_KARAOKE,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageKaraoke {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_RAP,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageWrap {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_FAQ,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageFaqs {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_FEEDBACK,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageFeedback {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.PROFILE_SETTINGS,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <Settings {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // The old Broadcast page was a leftover from the original template: it
    // called service functions that never existed and the backend has no
    // broadcast endpoints. Scheduled admin pushes live on Notifications
    // (/admin/admin-notifications); redirect so old bookmarks keep working.
    path: routePaths.BROADCAST_NOTIFICATIONS,
    element: () => <Navigate to={routePaths.MANAGE_NOTIFICATIONS} replace />,
  },
  {
    path: routePaths.MANAGE_TICKET,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageTicket {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.POST_DETAIL,
    element: (props = {}) => (
      <ProtectedRoute>
        <PostDetail {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.COMMENT_DETAIL,
    element: (props = {}) => (
      <ProtectedRoute>
        <CommentDetail {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.USER_REPORT_DETAIL,
    element: (props = {}) => (
      <ProtectedRoute>
        <UserReportDetail {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // Same page as a post report — the ticket targets the accused entry —
    // but scoped to CHEATING rows and showing the pagent it was played in.
    path: routePaths.CHEATING_DETAIL,
    element: (props = {}) => (
      <ProtectedRoute>
        <PostDetail {...props} reportType="CHEATING" />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.uploadKaraoke,
    element: (props = {}) => (
      <ProtectedRoute>
        <UploadKaraokeFile {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_DANCE,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageDance {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.uploadDance,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <UploadDanceFile {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_ADMIN_SETTINGS,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <AdminSettings {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // Restricted admin sub-accounts: create, choose per-account pages,
    // reset temporary passwords. Full admins only.
    path: routePaths.MANAGE_ADMIN_ACCOUNTS,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageAdminAccounts {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_GAMEPLAY_SETTINGS,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <GameplaySettings {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_FACE_VERIFICATION,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageFaceVerification {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_SEASON,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <ManageSeason {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // Appeals against automated moderation removals. Managers handle Reports,
    // so they handle Appeals too (mirrors /report/* + /admin/moderation/appeals/*).
    path: routePaths.MANAGE_APPEALS,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageAppeals {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // Multi-account vote abuse: device clusters, flagged users, blocked votes.
    // Admin-only, like the ban tooling it links to.
    path: routePaths.ANTI_CHEAT,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <AntiCheat {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_NOTIFICATIONS,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageNotifications {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_MESSAGES,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManageMessages {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_PATCH_UPDATES,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManagePatchUpdates {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.MANAGE_PAGENT_POSTS,
    element: (props = {}) => (
      <ProtectedRoute>
        <ManagePagentPosts {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.CURATED_MATCHES,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <CuratedMatches {...props} />
      </ProtectedRoute>
    ),
  },
  {
    path: routePaths.FILM_FEED,
    element: (props = {}) => (
      <ProtectedRoute requiredRole="admin">
        <FilmFeed {...props} />
      </ProtectedRoute>
    ),
  },
  {
    // Active Matches now lives on the Match & Energy page; keep old
    // bookmarks working with a redirect.
    path: routePaths.IN_PROGRESS_MATCHES,
    element: () => (
      <Navigate to={routePaths.MANAGE_GAMEPLAY_SETTINGS} replace />
    ),
  },
  {
    path: routePaths.OTHERS,
    element: () => <Navigate to={routePaths.DASHBOARD} replace />,
  },
];

export { routes, loginRoutes };
